import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo-somax-completa.png';

const Header = ({ onOpenChat }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center py-4 px-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img src={Logo} className="h-10"/>
            {/* <span className="text-2xl font-bold text-somax-dark">Somax</span> */}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            
            
            <Link 
              to="/" 
              className="text-somax-dark hover:text-somax-green font-medium transition-colors duration-300"
            >
              Home
            </Link>
             <Link 
              to="/about" 
              className="text-somax-dark hover:text-somax-green font-medium transition-colors duration-300"
            >
              Sobre nós
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button 
              onClick={onOpenChat}
              className="btn-primary text-sm"
            >
              Fale Conosco
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-somax-dark"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 px-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {/* <Link 
                to="/carro" 
                className="text-somax-dark hover:text-somax-green font-medium transition-colors duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Carros
              </Link>
              <Link 
                to="/caminhao" 
                className="text-somax-dark hover:text-somax-green font-medium transition-colors duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Caminhões
              </Link> */}
               <Link 
                to="/" 
                className="text-somax-dark hover:text-somax-green font-medium transition-colors duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
               Home
              </Link>
              <Link 
                to="/about" 
                className="text-somax-dark hover:text-somax-green font-medium transition-colors duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                Sobre Nós
              </Link>
               
              <button 
                onClick={() => {
                  onOpenChat();
                  setIsMenuOpen(false);
                }}
                className="btn-primary text-sm w-full"
              >
                Fale Conosco
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;